import gql from 'graphql-tag'
import base from '@/mixins/pagination/base'
import paramExtractor from '@/assets/modules/channels/paramExtractor'

export default {
  data () {
    return {
      channels: {}
    }
  },

  methods: {
    getChannelsIcon (gn) {
      let {icon, pack} = paramExtractor.extract(gn)
      return {
        name: icon,
        pack
      }
    },
    translateName (gn) {
      return paramExtractor.extract(gn).label
    },

    getAvailableBoards (channel) {
      let boards = this.getGroupedChannels[channel]

      let selectOptions = [{
        val: null,
        label: 'Select board'
      }]

      for (let b of boards) {
        selectOptions.push(this.prepSelectData(b, channel))
      }

      return selectOptions
    },

    prepSelectData (board, channel) {
      let rtr = {
        val: board.identity
      }

      rtr.sideVal = {
        identity: board.identity,
        pageUrl: board.pageUrl,
        viewUrl: board.viewUrl,
        editUrl: board.editUrl,
        channelName: channel
      }

      return rtr
    }
  },

  computed: {
    getGroupNames () {
      return Object.keys(this.getGroupedChannels)
    },

    /**
     * Tells what channels are connected but are invisible due to no
     * board being selected
     * @returns {Object}
     */
    getInvisibleChannels () {
      let visibleChannels = this.getGroupedChannels
      let allChannels = this.getData

      let invisibleChannels = {}

      for (let c of allChannels) {
        if (!visibleChannels[c.type]) invisibleChannels[c.type] = true
      }

      return invisibleChannels
    },

    getGroupedChannels () {
      let credentials = this.getData

      if (!credentials) {
        return {}
      }

      let groups = {}

      for (let c of credentials) {
        if (c.visible) {
          if (!groups[c.type]) {
            groups[c.type] = []
          }
  
          let obj = Object.assign({}, c)
          groups[c.type].push(obj)
        }
      }
      return groups
    },

    getData () {
      if ((this.$tours.mainPageTour || {}).isRunning) return []
      return (this.channels.credentials || {}).set || []
    },

    getCredentials () {
      return this.getData || []
    },

    getPaginationParams () {
      return {}
    }
  },

  mixins: [
    base
  ],

  // Apollo...
  apollo: {
    channels: {
      query: gql`query {
        channels: user {
          id,
          credentials {
            set {
              type,
              identity: id,
              id,
              label,
              visible,
              meta {
                __typename
      
                ... on UserCredentialsFacebookProfile {
                  name,
                  profileUrl
                },
      
                ... on UserCredentialsFacebookPage {
                  name,
                  pageUrl
                },
      
                ... on UserCredentialsGooglePlusProfile {
                  name
                }

                ... on  UserCredentialsSqwizPage{
                  viewUrl,
                  editUrl,
                  name: viewUrl,
                  categories {
                    id,
                    name
                  }
                },
                
                
                ... on UserCredentialsInformacijaShop {
                  shopUrl
                },
      
                ... on UserCredentialsShopamineShop {
                  shopUrl,
                  categories {
                    id,
                    name
                  }
                },
                
                ... on  UserCredentialsWooCommerceShop {
                  shopUrl
                },

                ... on UserCredentialsWordpressUser {
                  name,
                  productCategories { id, name },
                  postCategories { id, name }
                },

                ... on UserCredentialsShopifyShop {
                  shopUrl
                },
                
                ... on UserCredentialsInstagramProfile {
                  profileUrl
                },
                
                ... on UserCredentialsTwitterProfile {
                  profileUrl
                },
                
                ... on UserCredentialsPinterestProfile {
                  name
                },

                ... on UserCredentialsPinterestBoard {
                  name,
                  boardUrl,
                  imageUrl
                },

                ... on UserCredentialsPinterestBoard {
                  boardUrl,
                  name,
                  imageUrl
                },
                
                ... on UserCredentialsElasticEmailAccount {
                  accountUrl
                }
              }
            }
          }
        }
      }`,
      variables: {
      },
      fetchPolicy: 'cache-and-network'
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/pagination/providers/channels.js